import { useState } from "react";
import ThirdPartyLayout from "../ThirdPartyLayout";
import "../../../../styles/dashboard/third-party/ThirdPartyIndex.css";
import CurrencyText from "../../../../components/fragment/cur-text/CurrencyText";
import { RazorNumberFormat } from "../../../../components/razor-reuse";
import { ALL_ICONS } from "../../../../assets/icons/AllIcons";
import { useSelector } from "react-redux";
import RootState from "../../../../redux/type";
import NGNAccountDetailsModal from "./NgnAccountDetailsModal";
import CADAccountDetailsModal from "./CadAccountDetailsModal";
import USDAccountDetailsModal from "./UsdAccountDetailsModal";

const BlazeIndex = () => {
  const { blaze, third_party_info } = useSelector(
    (state: RootState) => state.thirdParty
  );

  type showModalProps = {
    ngn_view: boolean;
    cad_view: boolean;
    usd_view: boolean;
  };
  const [showModal, setShowModal] = useState<showModalProps>({
    ngn_view: false,
    usd_view: false,
    cad_view: false,
  });

  const getDetailsByCurrency = (param: string) => {
    if (param) {
      const obj = blaze?.find((chi: any) => chi?.currency === param);
      return obj;
    }
  };

  const accountList = [
    {
      name: "Canadian Dollar",
      currency: "CAD",
      value: blaze?.cad_details?.amount,
      gradientBg:
        "linear-gradient( to bottom , #263180 0%, #5063DB 60%, #5063DB 90% )",
      onFund: () => {
        setShowModal((prev) => {
          return { ...prev, cad_view: true };
        });
      },
      onSend: () => {},
      btnBg: "#293484",
    },
    {
      name: "Nigerian Naira",
      currency: "NGN",
      value: blaze?.ngn_details?.amount,
      gradientBg:
        "linear-gradient( to bottom , #191D20 0%, #000000 60%, #000000 90% )",
      btnBg: "#1D2124",
      onFund: () => {
        setShowModal((prev) => {
          return { ...prev, ngn_view: true };
        });
      },
      onSend: () => {},
    },
    {
      name: "United State Dollar",
      currency: "USD",
      value: blaze?.usd_details?.amount,
      gradientBg:
        "linear-gradient( to bottom , #734792 0%, #734792 60%, #734792 90% )",
      btnBg: "#1D2124",
      onFund: () => {
        setShowModal((prev) => {
          return { ...prev, usd_view: true };
        });
      },
      onSend: () => {},
    },
  ];

  return (
    <>
      <ThirdPartyLayout
        titleText="Here are the details about your blaize account"
        title="Blaaiz Account"
      >
        <div
          //   onClick={() => {
          //     console.log(blaze);
          //     console.log(third_party_info);
          //   }}
          className="blaze-index-wrapper-box-third-party"
        >
          {accountList?.map((chi, idx) => {
            return (
              <div
                style={{ background: chi?.gradientBg ? chi?.gradientBg : "" }}
                key={idx}
                className="card-amount-box"
              >
                <CurrencyText
                  imgSize={`3rem`}
                  text={chi?.name}
                  className="currency-text-box"
                  currency={chi?.currency}
                />
                <div className="label-value-box">
                  <p className="label">{`Current Balance`}</p>
                  <p className="value">
                    {RazorNumberFormat(chi?.value, { symbol: chi?.currency })}
                  </p>
                </div>
                {/* btn action box start  */}
                <div className="btn-action-box">
                  <div
                    style={{ backgroundColor: chi?.btnBg }}
                    className="btn-wrap"
                    onClick={() => {
                      chi?.onFund?.();
                    }}
                  >
                    <div className="icon-wrap">
                      <figure className="img-box">
                        {ALL_ICONS?.fund_icon}
                      </figure>
                    </div>
                    <p className="text">Fund</p>
                  </div>
                  {/* <div
                    style={{ backgroundColor: chi?.btnBg }}
                    className="btn-wrap"
                  >
                    <div className="icon-wrap">
                      <figure className="img-box">
                        {ALL_ICONS?.send_icon}
                      </figure>
                    </div>
                    <p className="text">Send</p>
                  </div>
                  <div
                    style={{ backgroundColor: chi?.btnBg }}
                    className="btn-wrap"
                  >
                    {" "}
                    <div className="icon-wrap">
                      <figure className="img-box">
                        {ALL_ICONS?.three_dots}
                      </figure>
                    </div>
                  </div> */}
                </div>
                {/* btn action box end */}
              </div>
            );
          })}
        </div>
      </ThirdPartyLayout>
      {/* modal start */}
      <NGNAccountDetailsModal
        visible={showModal?.ngn_view}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, ngn_view: false };
          });
        }}
      />
      <CADAccountDetailsModal
        visible={showModal?.cad_view}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, cad_view: false };
          });
        }}
      />
      <USDAccountDetailsModal
        visible={showModal?.usd_view}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, usd_view: false };
          });
        }}
      />
      {/* modal end */}
    </>
  );
};

export default BlazeIndex;
